export const languages = [
    {code: 'pl', label: 'Polski', shortLabel: 'PL'},
    {code: 'en', label: 'English', shortLabel: 'EN'},
];